// extracted by mini-css-extract-plugin
export default {"card":"Card_card__o5q61","card__name":"Card_card__name__OPL-9","card__price":"Card_card__price__CBkz0","card__descr":"Card_card__descr__NFYxO","card__btn":"Card_card__btn__T6OFX"};